/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S18_I4_TextInputs */

const tr_kullanim_s18_i4_text = /** @type {(inputs: Kullanim_S18_I4_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HMK Madde 193 uyarınca Şirket'in elektronik kayıtları, server günlükleri ve veritabanı kayıtları uyuşmazlıklarda kesin delil olarak kabul edilir.`)
};

const en_kullanim_s18_i4_text = /** @type {(inputs: Kullanim_S18_I4_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pursuant to HMK Madde 193, the Company's electronic records, server logs and database records are accepted as conclusive evidence in disputes.`)
};

const de_kullanim_s18_i4_text = /** @type {(inputs: Kullanim_S18_I4_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nach HMK Madde 193 werden die elektronischen Aufzeichnungen, Serverprotokolle und Datenbankeinträge des Unternehmens bei Streitigkeiten als zwingender Beweis anerkannt.`)
};

const ru_kullanim_s18_i4_text = /** @type {(inputs: Kullanim_S18_I4_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Согласно HMK Madde 193 электронные записи, журналы серверов и записи базы данных Компании принимаются в спорах в качестве бесспорного доказательства.`)
};

/**
* | output |
* | --- |
* | "Pursuant to HMK Madde 193, the Company's electronic records, server logs and database records are accepted as conclusive evidence in disputes." |
*
* @param {Kullanim_S18_I4_TextInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s18_i4_text = /** @type {((inputs?: Kullanim_S18_I4_TextInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S18_I4_TextInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s18_i4_text(inputs)
	if (locale === "de") return de_kullanim_s18_i4_text(inputs)
	if (locale === "ru") return ru_kullanim_s18_i4_text(inputs)
	return tr_kullanim_s18_i4_text(inputs)
});